<template>
  <div>
    <main role="main" style="padding-top:0px">
      <!-- <div class="container">
        <form id="form" action="/api">
           <div class="form-group">
            <label for="username">Username:</label>
            <input class="form-control" id="username" name="username" v-model="user"/>
          </div>
          <div class="form-group">
            <label for="share_link">Share Link:</label>
            <input class="form-control" id="share_link" name="share_link" v-model="link" />
          </div>
          <button type="submit" class="btn btn-primary" id='submit' @click="submit($event)">Submit</button>
        </form>
      </div>  -->
      <div
          v-if="showLoader"
          class="spinner-border"
          style="margin: auto; display: block; margin-top: 60px"
        ></div>
      <div class="container" id="container">
       <div class="row" style="padding-top: 85px; padding-bottom: 15px;" v-if="showLoader==false"><div class="msg-style">
         <p class="msg-text-style" style="font-size:25px">Something Went Wrong</p>
         <!-- <p class="msg-text-style">Please refresh this page if you don't see any data below.</p> -->
         <p class="msg-text-style" style="color:rgb(51, 51, 51);font-size:20px">There is some problem displaying the reports, please check back later.</p>
         </div>
        </div>
      </div>

      <div class="container text-center" style="display:none" id="containerDiv"></div>
      <div class="text-center" style="display: block;" id="containerDiv1"></div>
    </main>
  </div>
</template>
<script>
export default {
  data() {
    // https://tableau.123goecom.com/trusted
    return {
      // user:'vsomani@contata.com',
      user:'tbladmin',
      link:'https://tableau.123goecom.com/#/views/ExecutiveDashboard-Beta_16050375431590/ExecutiveDashboardVendorCentral',
      showLoader:true
    };
  },
  mounted(){
    this.submit()
  },
  methods: {
    submit(event) {
      //event.preventDefault();
      let payload = {
        username: this.user,
        url:this.link
      }
      let vm=this;
      this.$store.dispatch('fetchTicketForTableau',payload)
        // .then(res => {
        //   return res?res.json():{}
        // })
        .then((body) => {
          //document.getElementById("response").innerText = JSON.stringify(body);
         
          if (body.ticket === '-1') {
                vm.showLoader=false
                return;
            }
                // let url="https://tableau.123goecom.com/#/views/ExecutiveDashboard-Beta_16050375431590/ExecutiveDashboardVendorCentral"
                // url.pathname = '/trusted/' + body.ticket + url.pathname+"?:showVizHome=no&:embed=true";
                let iframe = document.createElement('iframe');
                iframe.src = "https://tableau.123goecom.com/trusted/"+body.ticket+"/views/ExecutiveDashboard-Beta_16050375431590/ExecutiveDashboardVendorCentral?iframeSizedToWindow=true&amp;:embed=y&amp;:showAppBanner=false&amp;:display_count=no&amp;:showVizHome=no"
                iframe.width = '800px';
                iframe.height = '600px';
                document.getElementById("containerDiv").appendChild(iframe);
               
                document.getElementById('containerDiv1').style.display="block"
                let iframe2 = document.createElement('iframe');
                iframe2.setAttribute("id","iframe2")
                iframe2.src = "https://tableau.123goecom.com/views/ExecutiveDashboard-Beta_16050375431590/ExecutiveDashboardVendorCentral?:embed=y#3"
                iframe2.width = '100%';
                iframe2.height = '1050px';
                document.getElementById("containerDiv1").appendChild(iframe2);
                $('#iframe2').on("load", function() {
                    document.getElementById('container').style.display="none"
                    vm.showLoader=false;
                });
                //iframe2.contentWindow.location.reload();
              if(window.localStorage.getItem('iframeLoaded')!=null){
                window.localStorage.removeItem('iframeLoaded');
                document.getElementById('container').style.display="none"
              }else{
                window.localStorage.setItem('iframeLoaded',true);
                location.reload()
              }
            // let url = new URL(document.getElementById('share_link').value);
            // url.pathname = '/trusted/' + body.ticket + url.pathname;
            // let iframe = document.createElement('iframe');
            // // iframe.src = src
            // iframe.src = url.href;
            // iframe.width = '800px';
            // iframe.height = '600px';
            // document.getElementById("containerDiv").appendChild(iframe);
    });
    },
  },
};
</script>
<style lang='scss'>
</style>